import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider, connect } from 'react-redux';
import thunk from 'redux-thunk';
import PropTypes from 'prop-types';

import { trackV2 } from 'utils/analytics';
import reducer from './reducers';
import Form from './components/Form';
import Terms from './components/Terms';
import SummaryContainer from './components/SummaryContainer';
import styles from './index.scss';
import { analyticsDataProps } from './shared/prop-types';
import AdyenSessionAdapter from './components/AdyenSessionAdapter';

class Checkout extends React.Component {
  store = createStore(reducer, this.props, applyMiddleware(thunk));

  componentDidMount() {
    trackV2({
      category: 'summit_upsell',
      page: 'cart',
      action: 'screen_enter',
      properties: { ...this.props.analytics_data }
    });
  }

  render() {
    const { dropInSessionEnabled } = this.props;
    return (
      <Provider store={this.store}>
        <>
          <div className={styles.container}>
            <SummaryContainer />
            {dropInSessionEnabled ? <ReduxAdyenForm /> : <Form />}
          </div>
          <Terms />
        </>
      </Provider>
    );
  }
}
const ReduxAdyenForm = connect((state) => ({
  duration: state.duration,
  sessionData: state.dropInSessionData,
  sessionId: state.dropInSessionId,
  clientKey: state.dropInClientKey,
  environment: state.dropInEnvironment,
  amount: state.products[state.duration].amountInMinorUnits,
  currency: state.products[state.duration].currency
}))(AdyenSessionAdapter);

Checkout.propTypes = {
  analytics_data: analyticsDataProps.isRequired,
  dropInSessionEnabled: PropTypes.bool.isRequired
};

export default Checkout;
